const ml = {
  nav: {
    home: "ഹോം",
    salons: "സലൂണുകൾ",
    membership: "മെമ്പർഷിപ്പ്",
    shop: "ഷോപ്പ്",
    academy: "അക്കാദമി",
    blog: "ജേണൽ",
    login: "ലോഗിൻ",
    logout: "ലോഗ് ഔട്ട്",
    dashboard: "ഡാഷ്ബോർഡ്",
    bookings: "എന്റെ ബുക്കിംഗുകൾ",
    loyalty: "ലോയൽറ്റി",
    profile: "പ്രൊഫൈൽ",
    orders: "എന്റെ ഓർഡറുകൾ",
    chat: "സംഭാഷണങ്ങൾ",
    notifications: "അറിയിപ്പുകൾ",
    partner: "പാർട്ണർ",
    admin: "അഡ്മിൻ",
    partner_panel: "പാർട്ണർ പാനൽ",
    admin_panel: "അഡ്മിൻ പാനൽ",
    login_register: "ലോഗിൻ / രജിസ്റ്റർ",
    skip_to_content: "ഉള്ളടക്കത്തിലേക്ക് പോകുക",
    account_menu: "അക്കൗണ്ട് മെനു",
    primary_nav: "പ്രധാനം",
    mobile_nav: "മൊബൈൽ നാവിഗേഷൻ",
    ai_advisor: "AI ഉപദേഷ്ടാവ്",
    cart: "ഷോപ്പിംഗ് കാർട്ട്",
  },
  footer: {
    tagline: "ഇന്ത്യയുടെ പ്രീമിയം സലൂൺ ബുക്കിംഗ് പ്ലാറ്റ്‌ഫോം — ലക്ഷ്വറി ബ്യൂട്ടി നിങ്ങളുടെ വിരൽത്തുമ്പിൽ.",
    company: "കമ്പനി",
    about: "ഞങ്ങളെക്കുറിച്ച്",
    how_it_works: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
    partners: "പാർട്ണർമാർക്കായി",
    stylists: "സ്റ്റൈലിസ്റ്റുകൾക്കായി",
    careers: "കരിയർ",
    contact: "ബന്ധപ്പെടുക",
    support: "സഹായം",
    faq: "പതിവ് ചോദ്യങ്ങൾ",
    help: "ഹെൽപ്പ് സെന്റർ",
    privacy: "സ്വകാര്യതാ നയം",
    terms: "സേവന നിബന്ധനകൾ",
    refund: "റീഫണ്ട് നയം",
    services: "സേവനങ്ങൾ",
    salons: "സലൂണുകൾ",
    membership: "മെമ്പർഷിപ്പ്",
    shop: "ഷോപ്പ്",
    academy: "അക്കാദമി",
    connect: "ബന്ധപ്പെടുക",
    newsletter_title: "ഞങ്ങളുടെ ന്യൂസ്‌ലെറ്ററിൽ ചേരൂ",
    newsletter_sub: "ബ്യൂട്ടി ടിപ്പുകൾ, പ്രത്യേക ഓഫറുകൾ, സ്പാം ഇല്ല.",
    newsletter_placeholder: "നിങ്ങളുടെ ഇമെയിൽ",
    newsletter_cta: "സബ്സ്ക്രൈബ് ചെയ്യുക",
    copyright: "© {{year}} Fayriza. എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.",
    made_in: "ഇന്ത്യയിൽ നിർമ്മിച്ചത്",
  },
  home: {
    hero_eyebrow: "ഇന്ത്യയുടെ പ്രീമിയം സലൂൺ ശൃംഖല",
    hero_title: "നിങ്ങളുടെ മികച്ച സലൂൺ അനുഭവം കണ്ടെത്തൂ",
    hero_subtitle: "നിങ്ങൾക്ക് അടുത്തുള്ള മികച്ച സലൂണുകളിൽ അപ്പോയിന്റ്‌മെന്റ് ബുക്ക് ചെയ്യൂ — ലക്ഷ്വറി, സൗകര്യം, കരുതൽ.",
    search_placeholder: "സലൂണുകൾ, സേവനങ്ങൾ അല്ലെങ്കിൽ സ്റ്റൈലിസ്റ്റുകൾ തിരയുക…",
    search_cta: "ഒരു സലൂൺ കണ്ടെത്തൂ",
    featured_salons: "തിരഞ്ഞെടുത്ത സലൂണുകൾ",
    browse_all: "എല്ലാം ബ്രൗസ് ചെയ്യുക",
    view_all: "എല്ലാം കാണുക",
    categories_title: "വിഭാഗങ്ങൾ പര്യവേക്ഷണം ചെയ്യുക",
    categories_sub: "എല്ലാ അവസരത്തിനും തിരഞ്ഞെടുത്ത സേവനങ്ങൾ",
    why_title: "എന്തുകൊണ്ട് Fayriza",
    why_sub: "തുടക്കം മുതൽ അവസാനം വരെ ഒരു പ്രീമിയം അനുഭവം",
    why_1_title: "സ്ഥിരീകരിച്ച സലൂണുകൾ",
    why_1_body: "ഓരോ പാർട്ണർ സലൂണും തിരഞ്ഞെടുത്ത് ഗുണമേന്മ പരിശോധിച്ചിട്ടുണ്ട്.",
    why_2_title: "തൽക്ഷണ ബുക്കിംഗ്",
    why_2_body: "തത്സമയ ലഭ്യത, നിമിഷങ്ങൾക്കുള്ളിൽ സ്ഥിരീകരിക്കുന്നു.",
    why_3_title: "സുരക്ഷിത പേയ്‌മെന്റുകൾ",
    why_3_body: "Razorpay പിന്തുണയുള്ള, റീഫണ്ട് സംരക്ഷിത ഇടപാടുകൾ.",
    why_4_title: "ലോയൽറ്റിയും റിവാർഡുകളും",
    why_4_body: "ഓരോ സന്ദർശനത്തിലും പോയിന്റുകൾ നേടൂ, ആനുകൂല്യങ്ങൾക്കായി റിഡീം ചെയ്യൂ.",
    testimonials_title: "ഞങ്ങളുടെ കമ്മ്യൂണിറ്റി ഇഷ്ടപ്പെടുന്നു",
    cta_title: "തിളങ്ങാൻ തയ്യാറാണോ?",
    cta_sub: "ആയിരക്കണക്കിന് Fayriza അംഗങ്ങളുടെ കൂട്ടത്തിൽ ചേരൂ.",
    cta_btn: "ആരംഭിക്കൂ",
  },
  salons: {
    title: "എല്ലാ സലൂണുകളും",
    subtitle: "നിങ്ങൾക്ക് അടുത്തുള്ള പ്രീമിയം പാർട്ണർ സലൂണുകൾ ബ്രൗസ് ചെയ്യൂ",
    filter: "ഫിൽട്ടർ",
    sort: "അടുക്കുക",
    sort_relevance: "പ്രസക്തി",
    sort_rating: "മികച്ച റേറ്റിംഗ്",
    sort_price_asc: "വില: കുറഞ്ഞത് മുതൽ ഉയർന്നത്",
    sort_price_desc: "വില: ഉയർന്നത് മുതൽ കുറഞ്ഞത്",
    sort_nearest: "ഏറ്റവും അടുത്തത്",
    search_placeholder: "പേര് അല്ലെങ്കിൽ സ്ഥലം അനുസരിച്ച് തിരയുക…",
    categories_all: "എല്ലാം",
    city_all: "എല്ലാ നഗരങ്ങളും",
    price_range: "വില പരിധി",
    open_now: "ഇപ്പോൾ തുറന്നിരിക്കുന്നു",
    no_results_title: "നിങ്ങളുടെ ഫിൽട്ടറുമായി പൊരുത്തപ്പെടുന്ന സലൂണുകളൊന്നുമില്ല",
    no_results_sub: "ഒരു ഫിൽട്ടർ നീക്കം ചെയ്യാനോ മറ്റൊരു സ്ഥലം തിരയാനോ ശ്രമിക്കൂ.",
    clear_filters: "ഫിൽട്ടറുകൾ മായ്ക്കുക",
    showing: "{{count}} സലൂണുകൾ കാണിക്കുന്നു",
    loading: "സലൂണുകൾ ലോഡ് ചെയ്യുന്നു…",
    book_now: "ഇപ്പോൾ ബുക്ക് ചെയ്യൂ",
    from: "മുതൽ",
    per_service: "സേവനത്തിന്",
    results: "ഫലങ്ങൾ",
    filters_title: "ഫിൽട്ടറുകൾ",
    reset_all: "എല്ലാം റീസെറ്റ് ചെയ്യുക",
    category: "വിഭാഗം",
    min_rating: "കുറഞ്ഞ റേറ്റിംഗ്",
    any_rating: "ഏതെങ്കിലും റേറ്റിംഗ്",
    for_gender: "ആർക്കുവേണ്ടി",
    gender_women: "സ്ത്രീകൾ",
    gender_men: "പുരുഷന്മാർ",
    gender_unisex: "എല്ലാവർക്കും",
    cat_bridal: "വധു",
    cat_spa: "സ്പാ",
  },
  salon: {
    book_now: "ഇപ്പോൾ ബുക്ക് ചെയ്യൂ",
    message: "സന്ദേശം",
    favourite: "പ്രിയപ്പെട്ടത്",
    unfavourite: "പ്രിയപ്പെട്ടതിൽ നിന്ന് നീക്കുക",
    share: "പങ്കിടുക",
    directions: "വഴികൾ",
    call: "വിളിക്കുക",
    services: "സേവനങ്ങൾ",
    stylists: "സ്റ്റൈലിസ്റ്റുകൾ",
    reviews: "അവലോകനങ്ങൾ",
    availability: "ലഭ്യത",
    gallery: "ഗാലറി",
    about: "കുറിച്ച്",
    working_hours: "പ്രവൃത്തി സമയം",
    amenities: "സൗകര്യങ്ങൾ",
    contact: "ബന്ധപ്പെടുക",
    overview: "അവലോകനം",
    location: "സ്ഥലം",
    reviews_count: "{{count}} അവലോകനങ്ങൾ",
    rating_out_of: "5-ൽ {{rating}}",
    select_service: "ബുക്ക് ചെയ്യാൻ ഒരു സേവനം തിരഞ്ഞെടുക്കുക",
    duration: "ദൈർഘ്യം",
    minutes: "{{min}} മിനിറ്റ്",
    open: "തുറന്നിരിക്കുന്നു",
    closed: "അടച്ചിരിക്കുന്നു",
    closes_at: "{{time}}-ന് അടയ്ക്കുന്നു",
    opens_at: "{{time}}-ന് തുറക്കുന്നു",
  },
  booking: {
    title: "അപ്പോയിന്റ്‌മെന്റ് ബുക്ക് ചെയ്യൂ",
    step_services: "സേവനങ്ങൾ",
    step_stylist: "സ്റ്റൈലിസ്റ്റ്",
    step_datetime: "തീയതിയും സമയവും",
    step_review: "അവലോകനം",
    step_pay: "പേയ്‌മെന്റ്",
    select_services: "സേവനങ്ങൾ തിരഞ്ഞെടുക്കുക",
    select_stylist: "സ്റ്റൈലിസ്റ്റിനെ തിരഞ്ഞെടുക്കുക",
    any_stylist: "ലഭ്യമായ ഏതെങ്കിലും സ്റ്റൈലിസ്റ്റ്",
    select_date: "തീയതി തിരഞ്ഞെടുക്കുക",
    select_time: "സമയം തിരഞ്ഞെടുക്കുക",
    no_slots: "ഈ തീയതിക്ക് സ്ലോട്ടുകളൊന്നും ലഭ്യമല്ല",
    try_other_date: "മറ്റൊരു തീയതി പരീക്ഷിക്കുക",
    confirm: "ബുക്കിംഗ് സ്ഥിരീകരിക്കുക",
    cancel: "ബുക്കിംഗ് റദ്ദാക്കുക",
    reschedule: "പുനഃക്രമീകരിക്കുക",
    subtotal: "സബ്ടോട്ടൽ",
    discount: "കിഴിവ്",
    tax: "നികുതികളും ഫീസുകളും",
    total: "ആകെ",
    pay_now: "ഇപ്പോൾ അടയ്ക്കുക",
    pay_at_salon: "സലൂണിൽ അടയ്ക്കുക",
    use_wallet: "വാലറ്റ് ഉപയോഗിക്കുക",
    apply_offer: "ഓഫർ പ്രയോഗിക്കുക",
    offer_placeholder: "കോഡ് നൽകുക",
    apply: "പ്രയോഗിക്കുക",
    remove: "നീക്കം ചെയ്യുക",
    booking_confirmed: "ബുക്കിംഗ് സ്ഥിരീകരിച്ചു!",
    booking_cancelled: "ബുക്കിംഗ് റദ്ദാക്കി",
    booking_ref: "ബുക്കിംഗ് ഐഡി",
    when: "എപ്പോൾ",
    where: "എവിടെ",
    who: "ആരുമായി",
    notes: "ഒരു കുറിപ്പ് ചേർക്കുക (ഓപ്ഷണൽ)",
    notes_placeholder: "അലർജികൾ, മുൻഗണനകൾ…",
    upcoming: "വരാനിരിക്കുന്നവ",
    past: "കഴിഞ്ഞത്",
    cancelled: "റദ്ദാക്കി",
    view_details: "വിശദാംശങ്ങൾ കാണുക",
    download_receipt: "രസീത് ഡൗൺലോഡ് ചെയ്യുക",
    rate_visit: "ഈ സന്ദർശനം റേറ്റ് ചെയ്യുക",
  },
  auth: {
    login_title: "സ്വാഗതം",
    login_sub: "Fayriza-യിലേക്ക് തുടരാൻ സൈൻ ഇൻ ചെയ്യുക",
    register_title: "അക്കൗണ്ട് സൃഷ്ടിക്കുക",
    register_sub: "ഇന്ത്യയുടെ പ്രീമിയം സലൂൺ ശൃംഖലയിൽ ചേരൂ",
    email: "ഇമെയിൽ",
    email_placeholder: "you@example.com",
    password: "പാസ്‌വേഡ്",
    password_placeholder: "കുറഞ്ഞത് 8 അക്ഷരങ്ങൾ",
    phone: "ഫോൺ നമ്പർ",
    phone_placeholder: "10 അക്ക മൊബൈൽ നമ്പർ",
    name: "മുഴുവൻ പേര്",
    name_placeholder: "നിങ്ങളുടെ പേര്",
    otp: "OTP നൽകുക",
    otp_placeholder: "6 അക്ക കോഡ്",
    send_otp: "OTP അയയ്ക്കുക",
    verify_otp: "പരിശോധിക്കുക",
    resend_otp: "OTP വീണ്ടും അയയ്ക്കുക",
    resend_in: "{{s}}സെക്കൻഡിൽ വീണ്ടും അയയ്ക്കുക",
    login_cta: "സൈൻ ഇൻ",
    register_cta: "അക്കൗണ്ട് സൃഷ്ടിക്കുക",
    forgot_password: "പാസ്‌വേഡ് മറന്നോ?",
    reset_password: "പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യുക",
    reset_sub: "നിങ്ങളുടെ ഇമെയിൽ നൽകൂ, ഞങ്ങൾ റീസെറ്റ് ലിങ്ക് അയയ്ക്കാം",
    reset_sent: "റീസെറ്റ് ലിങ്ക് നിങ്ങളുടെ ഇമെയിലിലേക്ക് അയച്ചു",
    new_password: "പുതിയ പാസ്‌വേഡ്",
    confirm_password: "പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
    social_login: "അല്ലെങ്കിൽ ഇത് ഉപയോഗിച്ച് തുടരുക",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ഇമെയിൽ പരിശോധിക്കുക",
    verify_email_sub: "{{email}}-ലേക്ക് ഞങ്ങൾ ഒരു സ്ഥിരീകരണ ലിങ്ക് അയച്ചു",
    resend_email: "സ്ഥിരീകരണ ഇമെയിൽ വീണ്ടും അയയ്ക്കുക",
    accept_terms: "നിബന്ധനകളും സ്വകാര്യതാ നയവും ഞാൻ അംഗീകരിക്കുന്നു",
    switch_to_register: "അക്കൗണ്ട് ഇല്ലേ?",
    switch_to_register_cta: "സൈൻ അപ്പ് ചെയ്യുക",
    switch_to_login: "ഇതിനകം ഒരു അക്കൗണ്ട് ഉണ്ടോ?",
    switch_to_login_cta: "സൈൻ ഇൻ ചെയ്യുക",
    remember_me: "എന്നെ ഓർക്കുക",
    phone_or_email: "ഫോൺ അല്ലെങ്കിൽ ഇമെയിൽ",
    use_phone: "പകരം ഫോൺ ഉപയോഗിക്കുക",
    use_email: "പകരം ഇമെയിൽ ഉപയോഗിക്കുക",
  },
  profile: {
    title: "എന്റെ പ്രൊഫൈൽ",
    edit_profile: "പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
    change_password: "പാസ്‌വേഡ് മാറ്റുക",
    avatar: "പ്രൊഫൈൽ ഫോട്ടോ",
    upload_photo: "ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക",
    name: "മുഴുവൻ പേര്",
    phone: "ഫോൺ നമ്പർ",
    email: "ഇമെയിൽ",
    dob: "ജനന തീയതി",
    gender: "ലിംഗം",
    gender_male: "പുരുഷൻ",
    gender_female: "സ്ത്രീ",
    gender_other: "മറ്റുള്ളവ",
    address: "വിലാസം",
    city: "നഗരം",
    pincode: "പിൻകോഡ്",
    save: "മാറ്റങ്ങൾ സംരക്ഷിക്കുക",
    saved: "പ്രൊഫൈൽ അപ്ഡേറ്റ് ചെയ്തു",
    current_password: "നിലവിലെ പാസ്‌വേഡ്",
    current_password_placeholder: "നിലവിലെ പാസ്‌വേഡ് നൽകുക",
    new_password: "പുതിയ പാസ്‌വേഡ്",
    new_password_placeholder: "കുറഞ്ഞത് 8 അക്ഷരങ്ങൾ",
    password_changed: "പാസ്‌വേഡ് വിജയകരമായി മാറ്റി",
  },
  dashboard: {
    title: "ഡാഷ്ബോർഡ്",
    welcome: "സ്വാഗതം, {{name}}",
    upcoming_bookings: "വരാനിരിക്കുന്ന ബുക്കിംഗുകൾ",
    no_upcoming: "വരാനിരിക്കുന്ന അപ്പോയിന്റ്‌മെന്റുകളൊന്നുമില്ല",
    book_a_salon: "ഒരു സലൂൺ ബുക്ക് ചെയ്യുക",
    favourites: "പ്രിയപ്പെട്ട സലൂണുകൾ",
    no_favourites: "നിങ്ങൾ ഇതുവരെ ഒരു സലൂണും പ്രിയപ്പെട്ടതായി അടയാളപ്പെടുത്തിയിട്ടില്ല",
    loyalty_points: "ലോയൽറ്റി പോയിന്റുകൾ",
    wallet_balance: "വാലറ്റ് ബാലൻസ്",
    recent_activity: "സമീപകാല പ്രവർത്തനം",
    quick_actions: "പെട്ടെന്നുള്ള പ്രവർത്തനങ്ങൾ",
    view_all: "എല്ലാം കാണുക",
    manage_membership: "മെമ്പർഷിപ്പ് നിയന്ത്രിക്കുക",
    top_up_wallet: "വാലറ്റ് ടോപ്പ് അപ്പ് ചെയ്യുക",
    refer_friend: "ഒരു സുഹൃത്തിനെ റഫർ ചെയ്യുക",
  },
  common: {
    loading: "ലോഡ് ചെയ്യുന്നു…",
    error: "എന്തോ കുഴപ്പം സംഭവിച്ചു",
    retry: "വീണ്ടും ശ്രമിക്കുക",
    no_results: "ഫലങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
    search: "തിരയുക",
    filter: "ഫിൽട്ടർ",
    sort: "അടുക്കുക",
    view_all: "എല്ലാം കാണുക",
    see_more: "കൂടുതൽ കാണുക",
    see_less: "കുറച്ചു കാണുക",
    back: "തിരികെ",
    next: "അടുത്തത്",
    previous: "മുമ്പത്തേത്",
    submit: "സമർപ്പിക്കുക",
    cancel: "റദ്ദാക്കുക",
    delete: "ഇല്ലാതാക്കുക",
    edit: "എഡിറ്റ് ചെയ്യുക",
    save: "സംരക്ഷിക്കുക",
    close: "അടയ്ക്കുക",
    confirm: "സ്ഥിരീകരിക്കുക",
    continue: "തുടരുക",
    yes: "അതെ",
    no: "അല്ല",
    skip: "ഒഴിവാക്കുക",
    optional: "ഓപ്ഷണൽ",
    required: "ആവശ്യമാണ്",
    from: "മുതൽ",
    per: "ഓരോ",
    to: "വരെ",
    and: "ഉം",
    or: "അല്ലെങ്കിൽ",
    learn_more: "കൂടുതൽ അറിയുക",
    coming_soon: "ഉടൻ വരുന്നു",
    currency: "₹",
    minutes_short: "മിനിറ്റ്",
    hours_short: "മണി",
    km: "കിമീ",
    away: "അകലെ",
    stars: "നക്ഷത്രങ്ങൾ",
  },
  loyalty: {
    title: "Fayriza ലോയൽറ്റി",
    subtitle: "ഓരോ സന്ദർശനത്തിലും പോയിന്റുകൾ നേടൂ, റിവാർഡുകൾക്കായി റിഡീം ചെയ്യൂ",
    points: "പോയിന്റുകൾ",
    available_points: "ലഭ്യമായ പോയിന്റുകൾ",
    total_earned: "ആകെ നേടിയത്",
    total_redeemed: "ആകെ റിഡീം ചെയ്തത്",
    redeem: "റിഡീം ചെയ്യുക",
    history: "പോയിന്റ് ചരിത്രം",
    rewards: "റിവാർഡുകൾ",
    tier: "ടിയർ",
    how_it_works: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
    earn_title: "നേടുക",
    earn_body: "ചെലവഴിക്കുന്ന ഓരോ ₹10-നും 1 പോയിന്റ്. ഗോൾഡിൽ 2×, പ്ലാറ്റിനത്തിൽ 3×.",
    redeem_title: "റിഡീം ചെയ്യുക",
    redeem_body: "വാലറ്റ് ക്രെഡിറ്റ്, സൗജന്യ സേവനങ്ങൾ, അല്ലെങ്കിൽ പാർട്ണർ ആനുകൂല്യങ്ങൾക്കായി പോയിന്റുകൾ ഉപയോഗിക്കൂ.",
    empty_history: "ഇതുവരെ പോയിന്റ് പ്രവർത്തനങ്ങളൊന്നുമില്ല",
    empty_rewards: "ഇപ്പോൾ റിവാർഡുകളൊന്നും ലഭ്യമല്ല",
  },
  wallet: {
    title: "Fayriza വാലറ്റ്",
    subtitle: "ഒരിക്കൽ ടോപ്പ് അപ്പ് ചെയ്യൂ, തടസ്സമില്ലാതെ ബുക്ക് ചെയ്യൂ",
    balance: "ബാലൻസ്",
    available: "ലഭ്യമാണ്",
    topup: "ടോപ്പ് അപ്പ്",
    topup_cta: "പണം ചേർക്കുക",
    topup_amount: "തുക",
    history: "ഇടപാട് ചരിത്രം",
    empty_history: "ഇതുവരെ ഇടപാടുകളൊന്നുമില്ല",
    credit: "ക്രെഡിറ്റ്",
    debit: "ഡെബിറ്റ്",
    refund: "റീഫണ്ട്",
  },
  membership: {
    eyebrow: "പ്രത്യേക ആക്സസ്",
    hero_title: "Fayriza മെമ്പർഷിപ്പ് പ്ലാനുകൾ",
    hero_sub: "ഇന്ത്യയിലെ 500+ പ്രീമിയം സലൂണുകളിലുടനീളം പ്രത്യേക കിഴിവുകളും മുൻഗണനാ ബുക്കിംഗും ലക്ഷ്വറി ആനുകൂല്യങ്ങളും അൺലോക്ക് ചെയ്യൂ.",
    plans: "മെമ്പർഷിപ്പ് പ്ലാനുകൾ",
    subscribe: "സബ്സ്ക്രൈബ് ചെയ്യുക",
    cancel: "മെമ്പർഷിപ്പ് റദ്ദാക്കുക",
    current: "നിലവിലെ പ്ലാൻ",
    gold: "ഗോൾഡ്",
    silver: "സിൽവർ",
    platinum: "പ്ലാറ്റിനം",
    per_year: "/വർഷം",
    per_month_approx: "≈ ₹{{amount}}/മാസം",
    cancel_anytime: "എപ്പോൾ വേണമെങ്കിലും റദ്ദാക്കാം",
    choose_title: "നിങ്ങളുടെ പ്ലാൻ തിരഞ്ഞെടുക്കുക",
    choose_sub: "എല്ലാ പ്ലാനുകളും വാർഷികമായി ബില്ല് ചെയ്യപ്പെടും. ഒരു പ്ലാൻ തിരഞ്ഞെടുത്ത് സ്ഥിരീകരിച്ച് ഉടൻ സജീവമാക്കൂ.",
    most_popular: "ഏറ്റവും ജനപ്രിയം",
    get_plan: "{{plan}} നേടുക",
    selected_proceed: "തിരഞ്ഞെടുത്തു — പേയ്‌മെന്റിലേക്ക് തുടരുക →",
    processing: "പ്രോസസ്സ് ചെയ്യുന്നു…",
    current_plan_label: "✓ നിലവിലെ പ്ലാൻ",
    welcome_back: "തിരികെ സ്വാഗതം, {{name}}!",
    member_label: "Fayriza {{tier}} അംഗം",
    expires_in: "{{days}} ദിവസത്തിനുള്ളിൽ കാലഹരണപ്പെടുന്നു",
    renews_on: "{{date}}-ന് പുതുക്കുന്നു",
    your_discount: "നിങ്ങളുടെ കിഴിവ്",
    off_all: "എല്ലാ സേവനങ്ങൾക്കും ഓഫ്",
    expiring_warn: "നിങ്ങളുടെ മെമ്പർഷിപ്പ് ഉടൻ കാലഹരണപ്പെടുന്നു. കിഴിവുകൾ നിലനിർത്താൻ ഇപ്പോൾ പുതുക്കൂ.",
    feature_comparison: "പൂർണ്ണ സവിശേഷത താരതമ്യം",
    feature: "സവിശേഷത",
    benefits_500: "500+ പാർട്ണർ സലൂണുകൾ",
    benefits_instant: "തൽക്ഷണ സജീവമാക്കൽ",
    benefits_cancel: "എപ്പോൾ വേണമെങ്കിലും റദ്ദാക്കുക",
    benefits_refund: "7 ദിവസത്തെ പണം തിരികെ",
    faq_title: "പതിവ് ചോദ്യങ്ങൾ",
    faq_cancel_q: "എനിക്ക് എന്റെ മെമ്പർഷിപ്പ് റദ്ദാക്കാനാകുമോ?",
    faq_cancel_a: "അതെ. ഡാഷ്ബോർഡിൽ നിന്ന് എപ്പോൾ വേണമെങ്കിലും നിങ്ങൾക്ക് റദ്ദാക്കാം. നിങ്ങളുടെ ബില്ലിംഗ് കാലയളവ് അവസാനിക്കുന്നതുവരെ ആനുകൂല്യങ്ങൾ തുടരും.",
    faq_all_salons_q: "കിഴിവ് എല്ലാ സലൂണുകൾക്കും ബാധകമാണോ?",
    faq_all_salons_a: "അതെ — ഇന്ത്യയിലുടനീളമുള്ള 500+ സ്ഥിരീകരിച്ച Fayriza പാർട്ണർ സലൂണുകളിലെല്ലാം കിഴിവ് സ്വയമേവ ബാധകമാണ്.",
    faq_refund_q: "7 ദിവസത്തെ പണം തിരികെ ഗ്യാരണ്ടി എന്താണ്?",
    faq_refund_a: "സജീവമാക്കിയ 7 ദിവസത്തിനുള്ളിൽ നിങ്ങൾ തൃപ്തനല്ലെങ്കിൽ, മെമ്പർഷിപ്പ് ഫീസ് ഞങ്ങൾ പൂർണ്ണമായും റീഫണ്ട് ചെയ്യും — ഒരു ചോദ്യവും ചോദിക്കാതെ.",
    faq_upgrade_q: "എനിക്ക് എന്റെ പ്ലാൻ അപ്‌ഗ്രേഡ് ചെയ്യാനാകുമോ?",
    faq_upgrade_a: "അതെ. എപ്പോൾ വേണമെങ്കിലും നിങ്ങൾക്ക് അപ്‌ഗ്രേഡ് ചെയ്യാം. ശേഷിക്കുന്ന കാലയളവിന്റെ ആനുപാതിക വ്യത്യാസം ഈടാക്കും.",
    activated: "🎉 Fayriza {{plan}} സജീവമാക്കി!",
    subscribe_failed: "സബ്സ്ക്രിപ്ഷൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  },
  shop: {
    eyebrow: "Fayriza ഷോപ്പ്",
    hero_title: "പ്രീമിയം ബ്യൂട്ടി & ഗ്രൂമിംഗ് ഉൽപ്പന്നങ്ങൾ",
    hero_sub: "തിരഞ്ഞെടുത്ത പ്രൊഫഷണൽ ഗ്രേഡ് അവശ്യ വസ്തുക്കൾ, നിങ്ങളുടെ വാതിൽക്കൽ എത്തിക്കുന്നു.",
    search_placeholder: "ഉൽപ്പന്നങ്ങൾ തിരയുക…",
    categories: "വിഭാഗങ്ങൾ",
    all_products: "എല്ലാ ഉൽപ്പന്നങ്ങളും",
    add_to_cart: "കാർട്ടിൽ ചേർക്കുക",
    added: "ചേർത്തു ✓",
    out_of_stock: "സ്റ്റോക്കിൽ ഇല്ല",
    checkout: "ചെക്ക്ഔട്ട്",
    cart: "കാർട്ട്",
    cart_empty: "നിങ്ങളുടെ കാർട്ട് ശൂന്യമാണ്",
    cart_empty_sub: "നിറയ്ക്കാൻ ഷോപ്പിംഗ് ആരംഭിക്കൂ",
    products: "ഉൽപ്പന്നങ്ങൾ",
    orders: "എന്റെ ഓർഡറുകൾ",
    no_orders: "ഇതുവരെ ഓർഡറുകളൊന്നുമില്ല",
    order_ref: "ഓർഡർ ഐഡി",
    order_status: "സ്ഥിതി",
    order_placed: "നൽകി",
    order_shipped: "ഷിപ്പ് ചെയ്തു",
    order_delivered: "എത്തിച്ചു",
    order_cancelled: "റദ്ദാക്കി",
    qty: "എണ്ണം",
    remove: "നീക്കം ചെയ്യുക",
    subtotal: "സബ്ടോട്ടൽ",
    shipping: "ഷിപ്പിംഗ്",
    tax: "നികുതി",
    total: "ആകെ",
    proceed_checkout: "ചെക്ക്ഔട്ടിലേക്ക് തുടരുക",
    shipping_address: "ഷിപ്പിംഗ് വിലാസം",
    place_order: "ഓർഡർ നൽകുക",
    continue_shopping: "ഷോപ്പിംഗ് തുടരുക",
    product_details: "ഉൽപ്പന്ന വിശദാംശങ്ങൾ",
    description: "വിവരണം",
    specifications: "സവിശേഷതകൾ",
    you_may_like: "നിങ്ങൾക്ക് ഇതും ഇഷ്ടപ്പെട്ടേക്കാം",
    related: "അനുബന്ധ ഉൽപ്പന്നങ്ങൾ",
  },
  academy: {
    eyebrow: "Fayriza അക്കാദമി",
    hero_title: "ഇന്ത്യയുടെ മികച്ച സ്റ്റൈലിസ്റ്റുകളിൽ നിന്ന് പഠിക്കൂ",
    hero_sub: "സാക്ഷ്യപ്പെടുത്തിയ വിദഗ്ധർ പഠിപ്പിക്കുന്ന പ്രൊഫഷണൽ ബ്യൂട്ടി & ഗ്രൂമിംഗ് കോഴ്സുകൾ. നിങ്ങളുടെ വേഗതയിൽ പഠിക്കൂ, സർട്ടിഫിക്കറ്റുകൾ നേടൂ, കരിയർ തുടങ്ങൂ.",
    search_placeholder: "കോഴ്സുകളോ ഇൻസ്ട്രക്ടർമാരോ തിരയുക…",
    stats_courses: "വിദഗ്ധ കോഴ്സുകൾ",
    stats_students: "വിദ്യാർത്ഥികൾ ചേർന്നു",
    stats_rating: "ശരാശരി റേറ്റിംഗ്",
    stats_certificate: "സർട്ടിഫിക്കറ്റ് ഉൾപ്പെടുന്നു",
    all: "എല്ലാ കോഴ്സുകളും",
    makeup: "മേക്കപ്പ്",
    hair: "മുടി",
    skin: "ചർമ്മം",
    nails: "നഖം",
    grooming: "ഗ്രൂമിംഗ്",
    courses: "കോഴ്സുകൾ",
    course: "കോഴ്സ്",
    enroll: "ഇപ്പോൾ ചേരുക",
    enrolled: "ചേർന്നു",
    modules: "മൊഡ്യൂളുകൾ",
    instructor: "ഇൻസ്ട്രക്ടർ",
    duration: "ദൈർഘ്യം",
    level: "നില",
    level_beginner: "തുടക്കക്കാരൻ",
    level_intermediate: "ഇടത്തരം",
    level_advanced: "വിപുലമായത്",
    certificate: "സർട്ടിഫിക്കറ്റ്",
    no_courses: "നിങ്ങളുടെ ഫിൽട്ടറുമായി പൊരുത്തപ്പെടുന്ന കോഴ്സുകളൊന്നുമില്ല",
    my_enrollments: "എന്റെ കോഴ്സുകൾ",
    continue_learning: "പഠനം തുടരുക",
    completed: "പൂർത്തിയാക്കി",
  },
  notifications: {
    title: "അറിയിപ്പുകൾ",
    empty: "നിങ്ങൾ എല്ലാം അപ്ഡേറ്റ് ആണ്",
    empty_sub: "ഇപ്പോൾ പുതിയ അറിയിപ്പുകളൊന്നുമില്ല",
    mark_all_read: "എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക",
    just_now: "ഇപ്പോൾ തന്നെ",
    minutes_ago: "{{n}}മി മുമ്പ്",
    hours_ago: "{{n}}മ മുമ്പ്",
    days_ago: "{{n}}ദി മുമ്പ്",
  },
  ai: {
    title: "Fayriza AI ഉപദേഷ്ടാവ്",
    subtitle: "AI പ്രവർത്തിപ്പിക്കുന്ന വ്യക്തിഗത ബ്യൂട്ടി നിർദ്ദേശങ്ങൾ.",
    placeholder: "ചർമ്മം, മുടി, മേക്കപ്പ് എന്നിവയെക്കുറിച്ച് എന്തും ചോദിക്കൂ…",
    send: "അയയ്ക്കുക",
    examples_title: "ചോദിച്ചുനോക്കൂ",
    ex_1: "എന്റെ മുഖത്തിന്റെ ആകൃതിക്ക് മികച്ച ഹെയർകട്ട്?",
    ex_2: "എണ്ണമയമുള്ള ചർമ്മത്തിന് സ്കിൻകെയർ ദിനചര്യ",
    ex_3: "2026-ലെ വധു മേക്കപ്പ് ട്രെൻഡുകൾ",
    thinking: "ചിന്തിക്കുന്നു…",
    disclaimer: "നിർദ്ദേശങ്ങൾ വിവരദായകം മാത്രം. മെഡിക്കൽ ആശങ്കകൾക്ക് ഒരു പ്രൊഫഷണലിനെ സമീപിക്കുക.",
  },
  marketing: {
    about: {
      eyebrow: "ഞങ്ങളുടെ കഥ",
      title: "സൗന്ദര്യം, പുനർവിഭാവനം ചെയ്തത്",
      sub: "Fayriza ഒരു ലളിതമായ ആശയത്തിൽ നിന്ന് ജനിച്ചു — ഇന്ത്യയ്ക്ക് അതിന്റെ കരകൗശലത്തെപ്പോലെ ശുദ്ധീകരിച്ച ഒരു സലൂൺ ബുക്കിംഗ് അനുഭവം അർഹിക്കുന്നു.",
      mission_title: "ഞങ്ങളുടെ ദൗത്യം",
      mission_body: "തടസ്സമില്ലാത്ത, വിശ്വസനീയമായ, ആഡംബരപൂർണ്ണമായ പ്ലാറ്റ്‌ഫോമിലൂടെ ദശലക്ഷക്കണക്കിന് ബ്യൂട്ടി പ്രേമികളെ ഇന്ത്യയുടെ മികച്ച സലൂണുകളുമായി ബന്ധിപ്പിക്കുക.",
      vision_title: "ഞങ്ങളുടെ കാഴ്ചപ്പാട്",
      vision_body: "എല്ലാവർക്കും ഗുണമേന്മയുള്ള ബ്യൂട്ടി, ആരോഗ്യ സേവനങ്ങൾ അവരുടെ വിരൽത്തുമ്പിൽ ലഭ്യമായ ഒരു ലോകം.",
      values_title: "ഞങ്ങളുടെ മൂല്യങ്ങൾ",
      value_1_title: "ഗുണമേന്മ ആദ്യം",
      value_1_body: "ഓരോ പാർട്ണർ സലൂണും പരിശോധിച്ച് ഞങ്ങളുടെ പ്രീമിയം മാനദണ്ഡങ്ങളിൽ നിലനിർത്തുന്നു.",
      value_2_title: "ഉപഭോക്താവിൽ ശ്രദ്ധ",
      value_2_body: "ബുക്കിംഗ് മുതൽ പരിചരണം വരെ — നിങ്ങളുടെ അനുഭവമാണ് ഞങ്ങളുടെ വഴികാട്ടി.",
      value_3_title: "പാർട്ണർമാരെ ശാക്തീകരിക്കുന്നു",
      value_3_body: "ഞങ്ങളുടെ സലൂണുകളും സ്റ്റൈലിസ്റ്റുകളും വളരുമ്പോൾ ഞങ്ങളും വളരുന്നു.",
      cta_title: "കഥയുടെ ഭാഗമാകൂ",
      cta_sub: "ഇന്ന് Fayriza കമ്മ്യൂണിറ്റിയിൽ ചേരൂ.",
    },
    how_it_works: {
      eyebrow: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
      title: "മൂന്ന് ഘട്ടങ്ങളിൽ ബുക്ക് ചെയ്യൂ",
      sub: "പ്രീമിയം സൗന്ദര്യം, ഊഹാപോഹങ്ങളില്ലാതെ.",
      step_1_title: "കണ്ടെത്തുക",
      step_1_body: "നിങ്ങൾക്ക് അടുത്തുള്ള സ്ഥിരീകരിച്ച സലൂണുകൾ, സേവനങ്ങൾ, സ്റ്റൈലിസ്റ്റുകൾ എന്നിവ ബ്രൗസ് ചെയ്യൂ.",
      step_2_title: "ബുക്ക് ചെയ്യുക",
      step_2_body: "നിങ്ങൾക്ക് യോജിച്ച സമയം തിരഞ്ഞെടുക്കൂ — തൽക്ഷണം സ്ഥിരീകരിക്കുന്നു.",
      step_3_title: "ആസ്വദിക്കുക",
      step_3_body: "പരിചരിക്കപ്പെടൂ. സന്ദർശനം റേറ്റ് ചെയ്യൂ. റിവാർഡുകൾ നേടൂ.",
      faq_title: "ദ്രുത ചോദ്യങ്ങൾ",
    },
    partners: {
      eyebrow: "സലൂൺ ഉടമകൾക്കായി",
      title: "Fayriza-യോടൊപ്പം വളരൂ",
      sub: "പുതിയ ക്ലയന്റുകളിലെത്തൂ, ഒഴിഞ്ഞ കസേരകൾ നിറയ്ക്കൂ, ആധുനിക സലൂൺ നടത്തൂ.",
      benefit_1_title: "കൂടുതൽ ഉപഭോക്താക്കൾ",
      benefit_1_body: "ഇന്ത്യയിലെ ഏറ്റവും വലിയ പ്രീമിയം ബ്യൂട്ടി പ്രേക്ഷകരിലേക്ക് പ്രവേശനം.",
      benefit_2_title: "സ്മാർട്ട് ബുക്കിംഗ്",
      benefit_2_body: "ഒരു ഡാഷ്ബോർഡിൽ നിന്ന് ഷെഡ്യൂളുകൾ, ജീവനക്കാർ, സേവനങ്ങൾ എന്നിവ നിയന്ത്രിക്കൂ.",
      benefit_3_title: "തൽക്ഷണ പേയ്‌മെന്റുകൾ",
      benefit_3_body: "സുരക്ഷിതവും വേഗത്തിലുമുള്ള പേഔട്ടുകൾ — കൈകൊണ്ട് പിന്തുടരേണ്ടതില്ല.",
      cta: "പാർട്ണർ ആകൂ",
    },
    stylists: {
      eyebrow: "സ്റ്റൈലിസ്റ്റുകൾക്കായി",
      title: "നിങ്ങളുടെ ക്ലയന്റ് അടിസ്ഥാനം നിർമ്മിക്കൂ",
      sub: "നിങ്ങളുടെ ജോലി കാണിക്കൂ, കണ്ടെത്തപ്പെടൂ, കരിയർ വളർത്തൂ.",
      cta: "സ്റ്റൈലിസ്റ്റായി അപേക്ഷിക്കുക",
    },
    careers: {
      eyebrow: "കരിയർ",
      title: "സൗന്ദര്യത്തിന്റെ ഭാവി രൂപപ്പെടുത്തൂ",
      sub: "വലുത് നിർമ്മിക്കുന്ന ഒരു ചെറിയ ടീമാണ് ഞങ്ങൾ. ചേരാൻ താൽപ്പര്യമുണ്ടോ?",
      openings_title: "തുറന്ന റോളുകൾ",
      no_openings: "ഇപ്പോൾ ഒഴിവുകളൊന്നുമില്ല. careers@fayriza.com-ൽ ഞങ്ങൾക്ക് ഒരു കുറിപ്പ് അയയ്ക്കൂ.",
    },
    contact: {
      eyebrow: "ബന്ധപ്പെടുക",
      title: "നിങ്ങളിൽ നിന്ന് കേൾക്കാൻ ഞങ്ങൾക്ക് ആഗ്രഹമുണ്ട്",
      sub: "ചോദ്യങ്ങൾ, ഫീഡ്ബാക്ക്, അല്ലെങ്കിൽ പങ്കാളിത്ത ആശയങ്ങൾ — ഞങ്ങൾ കേൾക്കാൻ തയ്യാറാണ്.",
      name: "നിങ്ങളുടെ പേര്",
      email: "നിങ്ങളുടെ ഇമെയിൽ",
      message: "സന്ദേശം",
      send: "സന്ദേശം അയയ്ക്കുക",
      sent: "നന്ദി — 24 മണിക്കൂറിനുള്ളിൽ ഞങ്ങൾ തിരികെ ബന്ധപ്പെടാം.",
      support_email: "സഹായം",
      partners_email: "പാർട്ണർമാർ",
      media_email: "മാധ്യമം",
    },
    faq: {
      eyebrow: "സഹായം",
      title: "പതിവ് ചോദ്യങ്ങൾ",
      sub: "സാധാരണ ചോദ്യങ്ങൾക്കുള്ള ദ്രുത ഉത്തരങ്ങൾ.",
    },
    legal: {
      privacy_title: "സ്വകാര്യതാ നയം",
      terms_title: "സേവന നിബന്ധനകൾ",
      refund_title: "റീഫണ്ട് നയം",
      last_updated: "അവസാനം അപ്ഡേറ്റ് ചെയ്തത് {{date}}",
    },
  },
  errors: {
    network: "നെറ്റ്‌വർക്ക് പിശക് — നിങ്ങളുടെ കണക്ഷൻ പരിശോധിക്കുക",
    unauthorised: "തുടരാൻ ദയവായി സൈൻ ഇൻ ചെയ്യുക",
    forbidden: "ഇതിലേക്ക് നിങ്ങൾക്ക് പ്രവേശനമില്ല",
    not_found: "നിങ്ങൾ തിരയുന്നത് ഞങ്ങൾക്ക് കണ്ടെത്താനായില്ല",
    server: "സെർവർ പിശക് — ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക",
    validation: "ഹൈലൈറ്റ് ചെയ്ത ഫീൽഡുകൾ ദയവായി പരിശോധിക്കുക",
    generic: "എന്തോ കുഴപ്പം സംഭവിച്ചു",
    page_not_found_title: "പേജ് കണ്ടെത്തിയില്ല",
    page_not_found_sub: "നിങ്ങൾ തിരയുന്ന പേജ് മാറ്റിയിരിക്കുന്നു അല്ലെങ്കിൽ ഇനി നിലവിലില്ല.",
    go_home: "ഹോമിലേക്ക് പോകുക",
  },
};

export default ml;
